module.exports = __webpack_public_path__ + "static/media/section8-dude.bbea66b7.png";